import { render } from "./DuplicatePatientDialog.vue?vue&type=template&id=763f6e61&scoped=true"
import script from "./DuplicatePatientDialog.vue?vue&type=script&lang=js"
export * from "./DuplicatePatientDialog.vue?vue&type=script&lang=js"

import "./DuplicatePatientDialog.vue?vue&type=style&index=0&id=763f6e61&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763f6e61"]])

export default __exports__